module.exports = __webpack_public_path__ + "img/KinokoTable37.8e5a3caf.jpg";